import { render, staticRenderFns } from "./SoloDriverCreatePage.vue?vue&type=template&id=2282941e&"
import script from "./SoloDriverCreatePage.vue?vue&type=script&lang=js&"
export * from "./SoloDriverCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./SoloDriverCreatePage.vue?vue&type=style&index=0&id=2282941e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports